import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { isServerSide } from "../utils";
import { getDictionary } from "./dictionary";
export const replaceInterpolation = (value, interpolation) => {
    if (!interpolation || interpolation.length === 0) {
        return value;
    }
    return value.replace(/\{(\d+)\}/gi, (_, index) => {
        return String(!interpolation || interpolation[Number(index)]) || "";
    });
};
// TODO: Should that be in translation or in UI lib?
export const TranslationKeyComponent = ({ value, keyValue }) => (_jsxs(_Fragment, { children: [_jsx("span", { style: { display: "none" }, className: "translation-key", children: keyValue }), value] }));
export const getTranslationValue = (dictionary) => (key, interpolation, defaultValue) => {
    if (dictionary[key] || dictionary[key] === "") {
        return replaceInterpolation(dictionary[key], interpolation);
    }
    return defaultValue !== null && defaultValue !== void 0 ? defaultValue : key;
};
/**
 * @deprecated use `useTranslation` instead from `@jti/ui` package
 * @param key key to identify the translation
 * @param interpolation values to replace placeholders in the translation
 * @param defaultValue default value to return if the key is not found
 * @returns translation value
 */
export const translate = (key, interpolation, defaultValue) => {
    const dictionary = getDictionary();
    return getTranslationValue(dictionary)(key, interpolation, defaultValue);
};
export const translateBackendErrorCode = (errorCode, defaultErrorMessage) => {
    if (isServerSide()) {
        return defaultErrorMessage;
    }
    const dictionary = getDictionary();
    if (!errorCode || !dictionary[errorCode]) {
        return defaultErrorMessage;
    }
    return dictionary[errorCode];
};
export const getErrorMessageFromError = (error, fallbackMessage) => {
    const typedError = error;
    if ("error_code" in typedError && typeof typedError.error_code !== "undefined") {
        return translateBackendErrorCode(typedError.error_code, fallbackMessage);
    }
    else if ("message" in typedError && typeof typedError.message !== "undefined") {
        return typedError.message;
    }
    return fallbackMessage;
};
//# sourceMappingURL=translation.js.map